export default __webpack_public_path__ + "static/media/doc-icon.c936fbf9.svg";